import axios from "axios";
import { authServiceLoginRequest, instance } from "./azure-ad.js";

const accessTokenRequest = {
  scopes: authServiceLoginRequest.scopes,
};
export const axiosInstance = axios.create({
  timeout: 20000,
});
axiosInstance.interceptors.request.use(
  async (config) => {
    const { accessToken } = await instance.acquireTokenSilent(
      accessTokenRequest
    );
    config.headers["Authorization"] = `Bearer ${accessToken}`;
    return config;
  },
  async (error) => {
    console.error(error);
    await instance.acquireTokenRedirect(accessTokenRequest);
    Promise.reject(error);
  }
);

export default axiosInstance;
